var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tamaños"},[_c('div',{staticClass:"scroles"},[_c('NavbarHorizontal'),_c('NavbarVertical')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }